import { Falcon } from 'modules/macro';
import { useTransitionState } from 'modules/hooks';
import { Box } from 'modules/v2/foundation/Box';
import { Button, IconButton } from 'modules/v2/navigation/buttons';
import { Message, Title, ToastContainer } from './styled';
export function Toast(props) {
    const { onClose, appearance = 'info', title, message, action, visible } = props;
    const transitionState = useTransitionState(visible, 200);
    const handleActionClick = () => {
        action === null || action === void 0 ? void 0 : action.onClick();
        onClose();
    };
    return (<ToastContainer $transitionState={transitionState} $appearance={appearance}>
      <Box flexDirection="column" width="100%">
        <Box width="100%" alignItems="flex-start" justifyContent="space-between" gap="xl">
          <Title $fontWeight="bold">{title}</Title>
          <IconButton type="button" $round onClick={onClose} appearance="glass" size="xs">
            <Falcon icon="xmark"/>
          </IconButton>
        </Box>

        {message && <Message $fontSize="small">{message}</Message>}
      </Box>

      {action && (<Button type="button" onClick={handleActionClick} appearance="glass" size="xs">
          {action.label}
        </Button>)}
    </ToastContainer>);
}
